import asset from "./assets";

export const maptype = { GoogleMap: "GoogleMap", BingMap: "BingMap" };
export const GoogleMapAPIKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const BingMapAPIKey = process.env.REACT_APP_BING_MAP_API_KEY;
export const AzureMapAPIKey = process.env.REACT_APP_AZURE_MAP_API_KEY;

export const drawEventType = { add: "add", edit: "edit" };
export const drawShapeType = {
  polyline: "polyline",
  polygon: "polygon",
  point: "point",
};
export const elementGroup = {
  Facility: "Facility",
  Areas: "Areas",
  Hazards: "Hazards",
  Elements: "Elements",
};
export const facilityCategory = [
  "facilityMarker",
  "perimeter",
  "netting",
  "poles",
];
export const areaCategory = ["landingAreas", "hittingAreas", "stalls"];
export const mandatoryShapes = [
  "facilityMarker",
  "perimeter",
  "landingAreas",
  "hittingAreas",
];
export const hazardCategory = [
  "fairways",
  "greens",
  "bunkers",
  "cartPaths",
  "waterHazards",
];
export const elementCategory = [
  "targets",
  "markers",
  "vegetation",
  "trees",
  "treeAreas",
];

export const emptyPropElements = [
  "facilityMarker",
  "perimeter",
  "greens",
  "cartPaths",
  "bunkers",
  "fairways",
  "netting",
  "poles",
];

export const zoneTypeList = {
  facilityMarker: "point",
  perimeter: "polygon",
  landingAreas: "polygon",
  hittingAreas: "polygon",
  stalls: "point",
  fairways: "polygon",
  greens: "polygon",
  cartPaths: "line",
  bunkers: "polygon",
  waterHazards: "polygon",
  vegetation: "polygon",
  treeAreas: "polygon",
  trees: "point",
  targets: "polygon",
  markers: "point",
  netting: "line",
  poles: "point",
};
export const heatMapZoneTypeList = {
  teebox: "polygon",
  perimeter: "polygon",
  green: "polygon",
  bunker: "polygon",
  fairway: "polygon",
  water: "polygon",
  cart: "line",
  path: "line",
  creek: "line",
  teeboxcenter: "point",
  greencenter: "point",
  centralpath: "line",
  apron: "polygon",
  fairwayapron: "polygon"
};
export const courseMapZoneTypeList = {
  teebox: "polygon",
  perimeter: "polygon",
  green: "polygon",
  bunker: "polygon",
  fairway: "polygon",
  teeboxcenter: "point",
  greencenter: "point",
  centralpath: "line",
  fcb: "point",
  // Facility elements
  creek: "line",
  tree: "point",
  clubhouse: "polygon",
  clubhousecenter: "point",
  background: "polygon",
  bridge: "polygon",
  hazard: "point",
  ocean: "polygon",
  rock: "point",
  vegetation: "polygon",
  sand: "polygon",
  lava: "polygon",
  water: "polygon",
  cart: "line",
  path: "line",
  cliff: "polygon",
  nativearea: "polygon",
  fixtures: "point",
  apron: "polygon",
  fairwayapron: "polygon",
  residence: "polygon",
  forest: "polygon",
  practicegreen: "polygon",
  practicebunker: "polygon",
  condo: "polygon",
  hotel: "polygon",
  business: "polygon",
  pool: "polygon",
  parkinglot: "polygon",
  street: "line",
  fence: "line",
  patio: "polygon",
  waterfall: "polygon",
  flowers: "polygon",
};
export const zonePrefixList = {
  facilityMarker: "FM",
  perimeter: "PM",
  landingAreas: "L",
  hittingAreas: "H",
  stalls: "S",
  fairways: "F",
  greens: "G",
  cartPaths: "C",
  bunkers: "B",
  waterHazards: "W",
  vegetation: "V",
  treeAreas: "TA",
  trees: "TR",
  targets: "T",
  markers: "M",
  netting: "N",
  poles: "P",
  apron: "A",
  fairwayapron: "FA",
};

export const singleShapeElements = ["perimeter", "facilityMarker"];
export const singleCourseElements = [
  "perimeter",
  "green",
  "fcb",
  "centralpath",
  "hazard", // as every hazard has different names ; need to query
];
export const continuousHoleFeatures = [
  "teebox",
  "teeboxcenter",
  "bunker",
  "creek",
  "water",
  "lava",
  "ocean",
  "bridge",
  "sand",
  "rock",
  "tree",
  'path',
  "nativearea",
  "forest",
  "practicegreen",
  "practicebunker",
  'cliff',
  'residence',
  'condo',
  'hotel',
  'business',
  'pool',
  'parkinglot',
  'street',
  'fence',
  'patio',
  'waterfall',
  'flowers',
];

export const defaultZoneColor = {
  facilityMarker: "#F34650",
  perimeter: "#F34650",
  hittingAreas: "#F8BB1F",
  stalls: "#00CEC6",
  fairways: "#9D7914",
  cartPaths: "#9D7914",
  bunkers: "#9D7914",
  vegetation: "#4DDBFF",
  treeAreas: "#00D0C0",
  trees: "#00D0C0",
  netting: "#F34650",
  greens: "#9D7914",
  poles: "#F34650",
  apron:"#a333ff",
  fairwayapron: "#66bb6a",
  residence: "#ff33c6",
  forest: "#dfff33",
  condo: "#ff6f00",
  hotel: "#ad1457",
  business: "#4a148c",
  pool: "#40c4ff",
  parkinglot: "#455a64",
  street: "#5d4037",
  fence: "#827717",
  patio: "#bf360c",
  waterfall: "#0288d1",
  flowers: "#e91e63",
};

export const landingAreasType = [
  {
    label: "GRASS",
    value: "grass",
  },
  {
    label: "WATER",
    value: "water",
  },
  {
    label: "ARTIFICIAL TURF",
    value: "artificial turf",
  },
  {
    label: "DECOMPOSED GRANITE",
    value: "decomposed granite",
  },
];
export const landingAreasColor = [
  {
    label: "GREEN",
    value: "#057716",
  },
  {
    label: "BLUE",
    value: "#1966E3",
  },
  {
    label: "BROWN",
    value: "#985E00",
  },
];

export const hittingAreasType = [
  {
    label: "GRASS",
    value: "grass",
  },
  {
    label: "MATS",
    value: "mats",
  },
  {
    label: "COVERED",
    value: "covered",
  },
  {
    label: "PAVEMENT",
    value: "pavement",
  },
];

export const hittingAreasPrimay = [
  {
    label: "YES",
    value: "yes",
  },
  {
    label: "NO",
    value: "no",
  },
];

export const stallAreasType = [
  {
    label: "GRASS",
    value: "grass",
  },
  {
    label: "MATS",
    value: "mats",
  },
  {
    label: "OTHER",
    value: "other",
  },
];

// standard
// tropical
// desert
// wetlands
// prairie
export const VegtationAreasType = [
  {
    label: "STANDARD",
    value: "standard",
  },
  {
    label: "TROPICAL",
    value: "tropical",
  },
  {
    label: "DESERT",
    value: "desert",
  },
  {
    label: "WETLANDS",
    value: "wetlands",
  },
  {
    label: "PRARIE",
    value: "prairie",
  },
];

export const waterHazardType = [
  {
    label: "BLUE",
    value: "#3174E0",
  },
  {
    label: "GREEN",
    value: "#00836F",
  },
];

export const targetType = [
  {
    label: "STANDARD",
    value: "standard",
  },
  {
    label: "TOP GOLF",
    value: "top golf",
  },
];

export const targetColor = [
  {
    label: "RED",
    value: "#CE0B0B",
  },
  {
    label: "ORANGE",
    value: "#F78806",
  },
  {
    label: "YELLOW",
    value: "#F8E71F",
  },
  {
    label: "GREEN",
    value: "#01B21C",
  },
  {
    label: "BLUE",
    value: "#1966E3",
  },
  {
    label: "PURPLE",
    value: "#7505C7",
  },
  {
    label: "BLACK",
    value: "#000000",
  },
  {
    label: "WHITE",
    value: "#FFFFFF",
  },
  {
    label: "GREY",
    value: "#919191",
  },
];

export const TreeAreasType = [
  {
    value: "standard",
    label: "STANDARD",
  },
  {
    value: "tropical",
    label: "TROPICAL",
  },
];

export const TreeAreasMod2Type = [
  {
    value: "small",
    label: "SMALL",
  },
  {
    label: "MEDIUM",
    value: "medium",
  },
  {
    label: "LARGE",
    value: "large",
  },
];

export const TreeType = [
  {
    value: "evergreen",
    label: "EVERGREEN",
  },
  {
    value: "deciduous",
    label: "DECIDOUS",
  },
  {
    value: "palm",
    label: "PALM",
  },
  {
    value: "cactus",
    label: "CACTUS",
  },
  {
    value: "other",
    label: "OTHER",
  },
];

export const TreeMod2Type = [
  {
    value: "small",
    label: "SMALL",
  },
  {
    label: "MEDIUM",
    value: "medium",
  },
  {
    label: "LARGE",
    value: "large",
  },
];
export const MarkerType = [
  {
    value: "FLAG",
    label: "FLAG",
  },
  {
    value: "POLE",
    label: "POLE",
  },
  {
    value: "OTHER",
    label: "OTHER",
  },
];

export const MarkerColorType = [
  {
    value: "#D6000E",
    label: "RED",
  },
  {
    value: "#F78806",
    label: "ORANGE",
  },
  {
    value: "#FAE804",
    label: "YELLOW",
  },
  {
    value: "#057716",
    label: "GREEN",
  },
  {
    value: "#1966E3",
    label: "BLUE",
  },
  {
    value: "#7505C7",
    label: "PURPLE",
  },
  {
    value: "#FFFFFF",
    label: "WHITE",
  },
  {
    value: "#000000",
    label: "BLACK",
  },
];
export const colorType = {
  ORANGE: "#f75e11",
  RED: "#f71111",
  YELLOW: "#f7d511",
  GREEN: "#11f711",
  BLUE: "#1115f7",
  PURPLE: "#3711f7",
  WHITE: "#ffffff",
  BLACK: "#0000",
};

// classification
export const classification = [
  { label: "Semi-private", value: "semi-private", id: "1" },
  { label: "Private", value: "private", id: "2" },
  { label: "Public", value: "public", id: "3" },
  { label: "Military", value: "military", id: "4" },
  { label: "Resort", value: "resort", id: "4" },
];

// status
export const status = [
  { value: "Active", id: "1" },
  { value: "Inactive", id: "0" },
];
export const statusForEdit = [
  { value: "Active", id: "1" },
  { value: "Inactive", id: "0" },
];

export const heatMapValidKeynames = [
  "perimeter",
  "bunker",
  "fairway",
  "water",
  "cart",
  "path",
  "creek",
];

export const courseMapValidKeynames = [
  "water",
  "cart",
  "path",
  "creek",
  "tree",
  "clubhouse",
  "clubhousecenter",
  "bridge",
  "background",
  "rock",
  "lava",
  "vegetation",
  "ocean",
  "sand",
  "cliff",
  "nativearea",
  "fixtures",
  "residence",
  "forest",
  "practicebunker",
  "practicegreen",
  "condo",
  "hotel",
  "business",
  "pool",
  "parkinglot",
  "street",
  "fence",
  "patio",
  "waterfall",
  "flowers",
];

export const defaultHeatMapZoneColor = {
  perimeter: "#F34650",
  teebox: "#FFFFFF",
  green: "#057716",
  fairway: "#057716",
  water: "#4DDBFF",
  cart: "#823141",
  path: "#9D6000",
  bunker: "#9D7914",
  creek: "#9D7914",
};


export const defaultCouseMapElementColor = {
  clubhousecenter: "#2FC8C2",
  perimeter: "#3934FB",
  fairway: "#1BFF00",
  path: "#FFFF",
  bunker: "#FE62FF",
  tree: "#00CC22",
  green: "#9E0F03",
  greencenter: "#8B8B8B",
  clubhouse: "#821EC6",
  background: "#F91E00",
  teebox: "#CA631C",
  teeboxcenter: "#CA631C",
  bridge: "#3F2B26",
  centralpath: "#F91E00",
  water: "#1A2687",
  creek: "#1A2687",
  hazard: "#B5A832",
  center: "#838383",
  back: "#226F9F",
  front: "#A21003",
  ocean: "#1A2687",
  vegetation: "#CA631C",
  lava: "#A21003",
  sand: "#B5A832",
  treeSmall:"#03cafc",
  treeMedium:"#f4fc03",
  // treeLarge:"#fc4a03",
  cliff: "#ffefcc",
  nativearea: "#fba200",
  fixtures:"#11c3d5",
  palm: "#0de91e",
  willow: "#0de9ac",
  desertShrub: "#bde90d",
  shrub: "#1a999f",
  conifer: "#2e8b57",
  deciduous: "#e9a745",
  apron: "#a333ff",
  fairwayapron: "#66bb6a",
  residence: "#ff33c6",
  forest: "#dfff33",
  practicebunker: "#c500ff",
  practicegreen: "#ff0081",
  pine: "#43a047",
  cypress: "#006400",
  cactus: "#6b8e23",
  condo: "#ff6f00",
  hotel: "#ad1457",
  business: "#4a148c",
  pool: "#40c4ff",
  parkinglot: "#455a64",
  street: "#5d4037",
  fence: "#827717",
  patio: "#bf360c",
  waterfall: "#0288d1",
  flowers: "#e91e63",
};

export const HoleFeatures = [
  {
    label: "TEEBOXES",
    value: "Teebox",
  },
  {
    label: "GREEN",
    value: "Green",
  },
  {
    label: "CENT. PATH",
    value: "Centralpath",
  },
  {
    label: "TEE CENTERS",
    value: "Teeboxcenter",
  },
  {
    label: "F/C/B",
    value: "fcb",
  },
  {
    label: "FAIRWAY",
    value: "Fairway",
  },
  {
    label: "BUNKERS",
    value: "Bunker",
  },
  {
    label: "HAZARDS",
    value: "Hazard",
  },
  {
    label: "PERIMETER",
    value: "Perimeter",
  },
  {
    label: "APRON",
    value: "Apron",
  },
  {
    label: "FAIRWAY APRON",
    value: "FairwayApron",
  },
];
export const HoleElements = [
  "Teebox",
  "Green",
  "Centralpath",
  "Fairway",
  "Bunker",
  "Perimeter",
  "Greencenter",
  "Apron",
  "FairwayApron"
];
export const CourseGPSVectorMapUpdateValues = {
  point: 1,
  line: 2,
  polygon: 3,
};
export const singlePointLayers = [
  "circlemarker",
  "circle",
  "marker",
  "draw:editstop",
];

export const fcbMarkerType = [
  {
    label: "FRONT",
    value: "front",
  },
  {
    label: "CENTER",
    value: "center",
  },
  {
    label: "BACK",
    value: "back",
  },
];
export const courseMapElementLimit = {
  teebox: 5,
  teeboxcenter: 5,
  hazard: 4,
  fcb: 3,
};

export const FacilityHazardElements = [
  {
    label: "TREE",
    value: "Tree",
  },
  {
    label: "WATER",
    value: "Water",
  },
  {
    label: "VEGETATION",
    value: "Vegetation",
  },
  {
    label: "CREEK",
    value: "Creek",
  },
  {
    label: "OCEAN",
    value: "Ocean",
  },
  {
    label: "BRIDGE",
    value: "Bridge",
  },
  {
    label: "SAND",
    value: "Sand",
  },
  {
    label: "ROCK",
    value: "Rock",
  },
  {
    label: "LAVA",
    value: "Lava",
  },
  {
    label: "CLIFF",
    value: "Cliff",
  },
  {
    label: "NATIVE AREA",
    value: "Nativearea",
  },
  {
    label: "FIXTURES",
    value: "Fixtures",
  },
  {
    label: "FOREST",
    value: "Forest",
  },
  {
    label: "WATERFALL",
    value: "Waterfall",
  },
  {
    label: "FLOWERS",
    value: "Flowers",
  },
];

export const faciltyHazardSize = [
  {
    label: "SMALL",
    value: 1,
  },
  {
    label: "MEDIUM",
    value: 2,
  },
  {
    label: "LARGE",
    value: 3,
  },
];
export const faciltyHazardType = [
  {
    label: "THIN",
    value: 1,
  },
  {
    label: "WIDE",
    value: 2,
  },
];
export const faciltyHazardCliffDesc = [
  {
    label: "NONE",
    value: 0,
  },
  {
    label: "STANDARD",
    value: 1,
  },
  {
    label: "FOLIAGE",
    value: 2,
  },
  {
    label: "ROCK",
    value: 3,
  },
  {
    label: "WOOD",
    value: 4,
  },
  {
    label: "DIRT",
    value: 5,
  },
  {
    label: "GRASS",
    value: 6,
  },
  {
    label: "SAND",
    value: 7,
  },
];

export const faciltyHazardCliffType = [
  {
    "label": "NONE",
    "value": 0
  },
  {
    "label": "NO FOLIAGE",
    "value": 1
  },
  {
    "label": "FOLIAGE",
    "value": 2
  }
]

export const faciltyHazardNativeAreaDesc = [
  {
    "label": "NONE",
    "value": 0
  },
  {
    "label": "WETLAND",
    "value": 1
  },
  {
    "label": "ROCKS",
    "value": 3
  },
  {
    "label": "WOOD CHIPS",
    "value": 4
  },
  {
    "label": "SHORT GRASS",
    "value": 5
  },
  {
    "label": "DESERT",
    "value": 7
  },
  {
    "label": "BUNKER GRASS",
    "value": 8
  },
  {
    "label": "REEDS",
    "value": 9
  },
  {
    "label": "SWAMPGRASS",
    "value": 10
  },
  {
    "label": "MEADOW GRASS",
    "value": 11
  },
  {
    "label": "LINKS GRASS",
    "value": 12
  },
  {
    "label": "PINE STRAW",
    "value": 13
  },
  {
    "label": "CACTUS",
    "value": 14
  },
  {
    "label": "LANDSCAPE SOIL",
    "value": 15
  }
]
export const faciltyHazardNativeAreaType = [
  {
    "label": "NONE",
    "value": 0
  },
  {
    "label": "DRY",
    "value": 1
  },
  {
    "label": "WET",
    "value": 2
  },
  {
    "label": "FOLIAGE",
    "value": 3
  },
  {
    "label": "STANDARD",
    "value": 4
  },
  {
    "label": "LOW DENSITY",
    "value": 5
  },
  {
    "label": "MEDIUM DENSITY",
    "value": 6
  },
  {
    "label": "HIGH DENSITY",
    "value": 7
  },
  {
    "label": "BROWN",
    "value": 8
  },
  {
    "label": "RED",
    "value": 9
  },
  {
    "label": "BLACK",
    "value": 10
  },
  {
    "label": "YELLOW",
    "value": 11
  },
  {
    "label": "GREEN",
    "value": 12
  },
  {
    "label": "NO FOLIAGE",
    "value": 13
  },
  {
    "label": "LEAF FOLIAGE",
    "value": 14
  },
  {
    "label": "SHRUB FOLIAGE",
    "value": 15
  },
  {
    "label": "LEAF AND SHRUB FOLIAGE",
    "value": 16
  }
]
export const faciltyHazardAreaSize = [
  {
    "label": "NONE",
    "value": 0
  },
  {
    "label": "SMALL",
    "value": 1
  },
  {
    "label": "MEDIUM",
    "value": 2
  },
  {
    "label": "LARGE",
    "value": 3
  },
  {
    "label": "SHORT",
    "value": 4
  },
  {
    "label": "TALL",
    "value": 5
  }
]

export const backroundType = [
	{
		label: "DRY DESERT",
		value: 4,
	},
	{
		label: "FOLIAGE DESERT",
		value: 5,
	},
	{
		label: "DRY FOREST",
		value: 7,
	},
	{
		label: "WET FOREST",
		value: 6,
	},
	{
		label: "TROPICAL FOREST",
		value: 1,
	},
	{
		label: "FOLIAGE DIRT",
		value: 9,
	},
	{
		label: "PLAINS",
		value: 10,
	},
	{
		label: "FARMLAND",
		value: 11,
	},
	{
		label: "RESIDENTIAL",
		value: 8,
	},
];

export const backroundDesc=[
  {
    label: "ROUGH",
    value: 1,
  },
  {
    label: "DESERT",
    value: 2,
  },
]


export const listMaxModField = {
  Tree: 2,
  Vegetation: 2,
  // Rock: 1,
  Rock: 2,
  Background:1,
  Clubhousecenter:0,
  Nativearea: 2,
  Fixtures: 2,
  PracticeBunker:1,
  Creek: 1,
  Lava: 1,
  Residence: 2,
  Condo: 2,
  Hotel: 2,
  Business: 2,
  ParkingLot: 1,
  Street: 1,
  Fence: 1,
  Water: 2,
};
export const leafletCustomIcon = {
  Tree: {
    iconUrl: asset.bigTree,
    // shadowUrl: asset.bigTree,
    iconSize: [30, 35], // size of the icon
    // shadowSize:   [50, 64], // size of the shadow
    iconAnchor: [15, 40], // point of the icon which will correspond to marker's location
    // shadowAnchor: [4, 62],  // the same for the shadow
    popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
  },
  Rock: {
    iconUrl: asset.bigRock,
  //  iconUrl: asset.bigRockBrown,
    // shadowUrl: asset.bigTree,
    iconSize: [20, 25], // size of the icon
    // shadowSize:   [50, 64], // size of the shadow
    iconAnchor: [10, 15], // point of the icon which will correspond to marker's location
    // shadowAnchor: [4, 62],  // the same for the shadow
    popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
  },
  Clubhousecenter: {
    iconUrl: asset.cluhouseIcon,
    // shadowUrl: asset.bigTree,
    iconSize: [30, 35], // size of the icon
    // shadowSize:   [50, 64], // size of the shadow
    iconAnchor: [15, 40], // point of the icon which will correspond to marker's location
    // shadowAnchor: [4, 62],  // the same for the shadow
    popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
  },
};

export const FacilityElements=[
  {
    label: "BACKGROUND",
    value: "Background",
  },
  {
    label: "CART PATH",
    value: "Path",
  },
  {
    label: "CLUBHOUSE",
    value: "Clubhouse",
  },
  {
    label: "CLUB CENTER",
    value: "Clubhousecenter",
  },
    {
    label: "PRACTICE GREEN",
    value: "PracticeGreen",
  },
    {
    label: "PRACTICE BUNKER",
    value: "PracticeBunker",
  },
  {
    label: "RESIDENCE",
    value: "Residence",
  },
  {
    label: "CONDO",
    value: "Condo",
  },
  {
    label: "HOTEL",
    value: "Hotel",
  },
  {
    label: "BUSINESS",
    value: "Business",
  },
  {
    label: "POOL",
    value: "Pool",
  },
  {
    label: "PARKING LOT",
    value: "ParkingLot",
  },
  {
    label: "STREET",
    value: "Street",
  },
  {
    label: "FENCE",
    value: "Fence",
  },
  {
    label: "PATIO",
    value: "Patio",
  },
]

export const CopyCourseDataTo = [
  { label: "New Course", value: "New Course"},
  { label: "Existing Course", value: "Existing Course"},
  { label: "Combine Two 9-Hole Courses", value: "Combine Courses"},
]
export const language_listings = [
  { label: "Japanese", value: 2 },
  { label: "Chinese", value: 3 },
  { label: "Mandarin Chinese", value: 4},
  { label: "Korean", value: 5},
]
export const BunkerPolygonType = [
  {
    label: "NONE",
    value: 0,
  },
  {
    label: "WHITE",
    value: 1,
  },
  {
    label: "TAN",
    value: 2,
  },
  {
    label: "RED",
    value: 3,
  },
  {
    label: "BLACK",
    value: 4,
  },
];
export const BunkerPolygonDescription = [
  {
    label: "NONE",
    value: 0,
  },
  {
    label: "CLEAN EDGE",
    value: 1,
  },
  {
    label: "ROUGH EDGE",
    value: 2,
  },
];
export const faciltyHazardTreeDescription = [
  {
    label: "NONE",
    value: 0,
  },
  {
    label: "PALM",
    value: 1,
  },
  {
    label: "WILLOW",
    value: 2,
  },
  {
    label: "DESERT SHRUB",
    value: 3,
  },
  {
    label: "SHRUB",
    value: 4,
  },
  {
    label: "CONIFER",
    value: 5,
  },
  {
    label: "DECIDUOUS",
    value: 6,
  },
  {
    label: "PINE",
    value: 7,
  },
  {
    label: "CYPRESS",
    value: 8,
  },
  {
    label: "CACTUS",
    value: 9,
  },
];
export const BridgePolygonDescription = [
  {
    label: "NONE",
    value: 0,
  },
  {
    label: "WOOD",
    value: 1,
  },
  {
    label: "STONE",
    value: 2,
  },
  {
    label: "CONCRETE",
    value: 3,
  },
];

// export const faciltyFixtureSize = [
//   {
//     label: "NONE",
//     value: 0,
//   },
//   {
//     label: "SMALL",
//     value: 1,
//   },
//   {
//     label: "MEDIUM",
//     value: 2,
//   },
//   {
//     label: "LARGE",
//     value: 3,
//   },
//   {
//     label: "SHORT",
//     value: 4,
//   },
//   {
//     label: "TALL",
//     value: 5,
//   },
// ];
export const faciltyFixtureType = [
  {
    label: "NONE",
    value: 0,
  },
  {
    label: "FOUNTAIN",
    value: 1,
  },
  {
    label: "BATHROOM",
    value: 2,
  },
  {
    label: "FOOD SERVICE",
    value: 3,
  },
  {
    label: "SHED",
    value: 4,
  },
];

export const faciltyForestType = [
  {
    label: "NONE",
    value: 0,
  },
  {
    label: "TROPICAL FOREST",
    value: 1,
  },
  {
    label: "DECIDUOUS FOREST",
    value: 2,
  },
  {
    label: "CONIFEROUS FOREST",
    value: 3,
  }
];

export const creekSize = [
  { label: "NONE", value: 0 },
  { label: "NARROW", value: 1 },
  { label: "MEDIUM", value: 2 },
  { label: "WIDE", value: 3 },
];

export const lavaType = [
  { label: "NONE", value: 0 },
  { label: "BLACK", value: 1 },
  { label: "RED", value: 2 },
  { label: "BROWN", value: 3 },
];

export const residenceDesc = [
  { label: "NONE", value: 0 },
  { label: "WHITE", value: 1 },
  { label: "LIGHT BLUE", value: 2 },
  { label: "DARK BLUE", value: 3 },
  { label: "GRAY", value: 4 },
  { label: "TAN", value: 5 },
  { label: "LIGHT YELLOW", value: 6 },
  { label: "GREEN", value: 7 },
  { label: "CREAM", value: 8 },
  { label: "BROWN", value: 9 },
  { label: "BRICK", value: 10 },
];

export const residenceType = [
  { label: "NONE", value: 0 },
  { label: "BLACK ROOF", value: 1 },
  { label: "LIGHT GRAY ROOF", value: 2 },
  { label: "DARK GRAY", value: 4 },
  { label: "TERRA COTA", value: 5 },
  { label: "RED ROOF", value: 6 },
  { label: "BROWN", value: 7 },
];

export const residenceSize = [
  { label: "NONE", value: 0 },
  { label: "SINGLE STORY", value: 1 },
  { label: "MULTI STORY", value: 2 },
];

export const buildingDesc = [
  { label: "NONE", value: 0 },
  { label: "WHITE", value: 1 },
  { label: "LIGHT BLUE", value: 2 },
  { label: "DARK BLUE", value: 3 },
  { label: "GRAY", value: 4 },
  { label: "TAN", value: 5 },
  { label: "LIGHT YELLOW", value: 6 },
  { label: "GREEN", value: 7 },
  { label: "CREAM", value: 8 },
  { label: "BROWN", value: 9 },
  { label: "BRICK", value: 10 },
  { label: "GLASS", value: 11 },
];

export const buildingType = [
  { label: "NONE", value: 0 },
  { label: "BLACK ROOF", value: 1 },
  { label: "LIGHT GRAY ROOF", value: 2 },
  { label: "DARK GRAY", value: 4 },
  { label: "TERRA COTA", value: 5 },
  { label: "RED ROOF", value: 6 },
  { label: "BROWN", value: 7 },
];

export const buildingSize = [
  { label: "NONE", value: 0 },
  { label: "SINGLE STORY", value: 1 },
  { label: "MULTI STORY", value: 2 },
  { label: "HIGH RISE", value: 3 },
];

export const clubhouseDesc = [
  { label: "NONE", value: 0 },
  { label: "CAPE COD", value: 1 },
  { label: "COLONIAL", value: 2 },
  { label: "MEDITERRANEAN", value: 3 },
  { label: "RUSTIC", value: 4 },
  { label: "MODERN", value: 5 },
];

export const clubhouseType = [
  { label: "NONE", value: 0 },
  { label: "WHITE", value: 1 },
  { label: "LIGHT BLUE", value: 2 },
  { label: "DARK BLUE", value: 3 },
  { label: "GRAY", value: 4 },
  { label: "TAN", value: 5 },
  { label: "LIGHT YELLOW", value: 6 },
  { label: "GREEN", value: 7 },
  { label: "CREAM", value: 8 },
  { label: "BROWN", value: 9 },
  { label: "BRICK", value: 10 },
  { label: "GLASS", value: 11 },
];

export const clubhouseSize = [
  { label: "NONE", value: 0 },
  { label: "SINGLE STORY", value: 1 },
  { label: "MULTI STORY", value: 2 },
];

export const parkingLotDesc = [
  { label: "NONE", value: 0 },
  { label: "ASPHALT", value: 1 },
  { label: "CONCRETE", value: 2 },
  { label: "GRAVEL", value: 3 },
];

export const cartPathDesc = [
  { label: "NONE", value: 0 },
  { label: "ASPHALT", value: 1 },
  { label: "CONCRETE", value: 2 },
  { label: "GRAVEL", value: 3 },
  { label: "DIRT", value: 4 },
  { label: "SAND", value: 5 },
];

export const streetDesc = [
  { label: "NONE", value: 0 },
  { label: "ASPHALT", value: 1 },
  { label: "CONCRETE", value: 2 },
  { label: "GRAVEL", value: 3 },
  { label: "DIRT", value: 4 },
];

export const streetSize = [
  { label: "NONE", value: 0 },
  { label: "SINGLE LANE", value: 1 },
  { label: "TWO LANE", value: 2 },
  { label: "FOUR LANE", value: 3 },
];

export const fenceDesc = [
  { label: "NONE", value: 0 },
  { label: "HEDGE", value: 1 },
  { label: "RAIL TIES", value: 2 },
  { label: "BRICK", value: 3 },
  { label: "STONE", value: 4 },
  { label: "WOOD", value: 5 },
  { label: "CHAIN LINK", value: 6 },
  { label: "NET", value: 7 },
  { label: "METAL", value: 8 },
  { label: "PICKET", value: 9 },
];

export const fenceSize = [
  { label: "NONE", value: 0 },
  { label: "SHORT", value: 1 },
  { label: "MEDIUM", value: 2 },
  { label: "TALL", value: 3 },
];

export const waterDesc = [
  { label: "NONE", value: 0 },
  { label: "CREEK", value: 1 },
  { label: "POND", value: 2 },
  { label: "LAKE", value: 3 },
];

export const waterType = [
  { label: "NONE", value: 0 },
  { label: "DRY", value: 1 },
  { label: "STANDARD", value: 2 },
  { label: "ROCKS", value: 3 },
  { label: "GRASS SWAMP", value: 4 },
  { label: "REEDS", value: 5 },
  { label: "GRASS", value: 6 },
  { label: "SAND", value: 7 },
  { label: "CONCRETE WALL", value: 8 },
  { label: "METAL WALL", value: 9 },
  { label: "STONE WALL", value: 10 },
  { label: "WOOD WALL", value: 11 },
];

export const waterSize = [
  { label: "NONE", value: 0 },
  { label: "SHORT", value: 1 },
  { label: "MEDIUM", value: 2 },
  { label: "TALL", value: 3 },
  { label: "SMALL", value: 4 },
  { label: "LARGE", value: 5 },
];
